import React, { useEffect, useState } from "react";
import GameCard from "../GameCard";
import slot_tab_img from "../../assets/images/game_card1.png";
import SlotGamePopup from "../SlotGamePopup";
const SlotTabCardsSection = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [casinoData, setCasinoData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCasinoData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/games/slot`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch slot data");
        }
        const data = await response.json();
        setCasinoData(data.lists);
        // setCasinoData(data.lists.slice(0, 9));
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCasinoData();
  }, []);

  const popupOpen = () => {
    setOpenPopup(true);
  };
  const popupClose = () => {
    setOpenPopup(false);
  };

  if (loading) return <p className="text-center">Loading slot...</p>;
  if (error) return <p className="text-center text-red-500">Error: {error}</p>;
  return (
    <>
      {casinoData.map((item, index) => (
        <GameCard
          key={index}
          game={item}
        />
      ))}
      {openPopup && <SlotGamePopup popupClose={popupClose} />}
    </>
  );
};

export default SlotTabCardsSection;
